import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, volumes, volumeIncludes } from '../data/volumes';
export function Volumes() {
  return <section aria-label="Cosa c'è dentro l'ebook" className="bg-transparent" data-id="element-229" data-mp="1845bcd7ch719">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: '19px',
      paddingBottom: "29px"
    }} data-id="element-230" data-mp="1822b70ch9xit">
        <div className="text-center" data-id="element-231" data-mp="1zv1mn9drb3mf">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-grape" data-id="element-232" data-mp="1zw4cddzcf00r">
            🌸 IL SISTEMA SIGMA SMART VISIVO™
          </p>
          <h2 className="mt-3 font-display text-3xl font-black text-plum sm:text-4xl" data-id="element-233" data-mp="24s1qrer1pwaw">
            Cosa troverai all'interno?
          </h2>
          <p className="mt-2 text-base text-plum/60" data-id="element-234" data-mp="1vsy646c8d8ua">
            6 tomi completi · 120+ pagine — Tutto ciò che ti serve in un unico posto.
          </p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-235" data-mp="fhat7my02jqy">
            {pillars.map(p => <span key={p} className="rounded-full border border-grape/25 bg-lilac-soft px-3 py-1 text-xs font-bold uppercase tracking-wide text-plum-soft" data-id="element-236" data-mp="kfm13s4qik6j">
                {p}
              </span>)}
          </div>
          <p className="mt-8 font-display text-lg font-black uppercase tracking-[0.18em] text-plum-soft" data-id="element-237" data-mp="3jb6dltg6ybds">
            📚 Il Metodo dei 6 Tomi
          </p>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-238" data-mp="3t6gfmh6lairk">
          {volumes.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="group flex flex-col rounded-2xl border border-grape/15 bg-white p-5 transition-colors duration-200 ease-out hover:border-grape/45" style={{
          paddingTop: "6px",
          paddingBottom: "7px"
        }} data-id="element-239" data-mp="b0bvyi0ef24o" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-240" data-mp="ps43w8xv5dwd">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-lilac-soft font-display text-lg font-black text-grape" data-id="element-241" data-mp="wu98ilgmgtjb">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-plum" data-id="element-242" data-mp="16r579zgpy1ao">
                  <span aria-hidden="true" data-id="element-243" data-mp="1bj5b42zwtecj">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-plum/65" data-id="element-244" data-mp="1fjfjtnf36iv3">{t.desc}</p>
              
            </motion.article>)}
        </div>

        
      </div>
    </section>;
}